import './common/TopBar.css';
import PrivacyPolicyContents from "./common/PrivacyPolicyContents"
import { useTranslation } from 'react-i18next';

export default function StorePrivacyPolicy() {
const { t } = useTranslation();


  return (
    <div className="page-wrapper">
      <div className="top-bar">
          <div className="top-bar-left"></div>
          <span className="top-bar-title">{t('privacy.title')}</span>
          <div className="top-bar-right"></div>
      </div>
      <PrivacyPolicyContents/>
    </div>
  )
}